module.exports = __webpack_public_path__ + "static/media/OW4@2x.4c768ae4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/OW/OW4@2x.png
// module id = 723
// module chunks = 0